import ComponentGuard from '../../../../components/ComponentGuard';
import { PORTAL_ROLES } from '../../../../config/roles';
import useSurvey from '../../../../hooks/useSurvey';
import { statuses } from '../../../../shared/utilities';
import Issue from './issue';
import Rooms from './rooms';

const Edit = () => {
  const survey = useSurvey();

  const issueMode =
    survey.status === statuses.UNASSIGNED ||
    survey.status === statuses.ISSUED ||
    survey.status === statuses.NOT_STARTED;

  return issueMode ? (
    <ComponentGuard
      label="Survey Issue"
      auth={{
        atLeast: PORTAL_ROLES.SURVEYOR,
        denyList: [PORTAL_ROLES.QUALITY_ASSURANCE],
      }}
    >
      <Issue />
    </ComponentGuard>
  ) : (
    <Rooms />
  );
};

export default Edit;
